"use client";

import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const teamMembers = [{
  name: "Marcus Sterling",
  role: "Lead Web Architect",
  description: "Specializing in high-performance React frameworks and scalable cloud infrastructure for modern enterprises.",
  initials: "MS",
  color: "bg-secondary/20 text-secondary border-secondary/50"
}, {
  name: "Elena Vance",
  role: "Creative Director",
  description: "Award-winning designer focused on premium brand identities and high-conversion landing page aesthetics.",
  initials: "EV",
  color: "bg-primary/20 text-primary border-primary/50"
}, {
  name: "Julian Thorne",
  role: "SEO & Content Strategist",
  description: "Data-driven expert dedicated to putting small businesses on the first page of search results nationwide.",
  initials: "JT",
  color: "bg-chart-3/20 text-chart-3 border-chart-3/50"
}, {
  name: "Sarah Chen",
  role: "Social Media Lead",
  description: "Master of engagement strategies that turn followers into loyal customers while you sleep.",
  initials: "SC",
  color: "bg-muted/20 text-foreground border-muted/50"
}];
export default function TheMindsBehindTheTech() {
  return;
}